/* eslint-disable import/no-deprecated */
import { handleInteractiveKeydown } from '@fullstory/util/a11y';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '../Typography';
import css from './index.module.scss';

interface HeaderProps {
  readonly date: Date;
  onPreviousClick?(): void;
  onNextClick?(): void;
}

/**
 * @deprecated
 */
export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const intl = useIntl();
  const getDateString = (date: Date) => intl.formatDate(date, { month: 'long', year: 'numeric' });

  return (
    <div data-component="DeprecatedDatepickerHeader" className={css.dateHeaderContainer}>
      <span
        role="button"
        tabIndex={0}
        className={classNames(css.nudgeBtn, css.arrowLeft)}
        onClick={props.onPreviousClick}
        onKeyDown={handleInteractiveKeydown(() => props.onPreviousClick?.())}
      />
      <span className={css.dateHeader}>
        <Typography variant="heading3">{getDateString(props.date)}</Typography>
      </span>
      <span
        role="button"
        tabIndex={0}
        className={classNames(css.nudgeBtn, css.arrowRight)}
        onClick={props.onNextClick}
        onKeyDown={handleInteractiveKeydown(() => props.onNextClick?.())}
      />
    </div>
  );
};
